// import { create } from 'zustand';
// import { persist } from 'zustand/middleware';

// interface LayoutState {
//   isSidebarOpen: boolean;
//   setIsSidebarOpen: (open: boolean) => void;
//   toggleSidebar: () => void;
//   _hasHydrated: boolean;
// }

// // Determine initial sidebar state based on screen size
// // Tablet (768px - 1023px): closed by default
// // Desktop (>= 1024px): open by default
// const getInitialSidebarState = (): boolean => {
//   if (typeof window === 'undefined') return false; // SSR: default to closed to prevent flash

//   const width = window.innerWidth;
//   const isTablet = width >= 768 && width < 1024;

//   return !isTablet; // Closed on tablet, open on desktop
// };

// export const useLayoutStore = create<LayoutState>()(
//   persist(
//     (set) => ({
//       isSidebarOpen: getInitialSidebarState(),
//       _hasHydrated: false,
//       setIsSidebarOpen: (open) => set({ isSidebarOpen: open }),
//       toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
//     }),
//     {
//       name: 'layout-storage',
//       partialize: (state) => ({ isSidebarOpen: state.isSidebarOpen }),
//       onRehydrateStorage: () => (state) => {
//         if (state) {
//           state._hasHydrated = true;
//           // Re-check screen size on hydration to ensure correct state
//           const width = window.innerWidth;
//           const isTablet = width >= 768 && width < 1024;

//           // Always close on tablet, regardless of stored preference
//           if (isTablet) {
//             state.isSidebarOpen = false;
//           }
//         }
//       },
//     }
//   )
// );

import { create } from 'zustand';

interface LayoutState {
  isSidebarOpen: boolean;
  setIsSidebarOpen: (open: boolean) => void;
  toggleSidebar: () => void;
  isPendingNavigation: boolean;
  setPendingNavigation: (pending: boolean) => void;
  isLoggingOut: boolean;
  setIsLoggingOut: (loggingOut: boolean) => void;
  /** Global logout modal open state — lifted from sidebar so child pages can intercept it */
  isLogoutModalOpen: boolean;
  setIsLogoutModalOpen: (open: boolean) => void;
}

export const useLayoutStore = create<LayoutState>((set) => ({
  isSidebarOpen: true,
  setIsSidebarOpen: (open) => set({ isSidebarOpen: open }),
  toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
  isPendingNavigation: false,
  setPendingNavigation: (pending) => set({ isPendingNavigation: pending }),
  isLoggingOut: false,
  setIsLoggingOut: (loggingOut) => set({ isLoggingOut: loggingOut }),
  isLogoutModalOpen: false,
  setIsLogoutModalOpen: (open) => set({ isLogoutModalOpen: open }),
}));
